import { createReducer, on } from '@ngrx/store';
import * as CatalogsVehicleActions from './catalog-vehicle.actions';
import { CatalogsVehicleState } from './catalog-vehicle.models';

export const initialState: CatalogsVehicleState = {
  catalogs: {},
  loading: false,
  error: null,
  currentUserGuid: null,
};

export const catalogsVehicleReducer = createReducer(
  initialState,
  on(CatalogsVehicleActions.loadCatalogsVehicle, (state, { userGuid }) => ({
    ...state,
    loading: true,
    error: null,
    currentUserGuid: userGuid,
  })),
  on(CatalogsVehicleActions.loadCatalogsVehicleSuccess, (state, { userGuid, catalogs }) => ({
    ...state,
    loading: false,
    error: null,
    catalogs: { [userGuid]: catalogs },
    currentUserGuid: userGuid,
  })),
  on(CatalogsVehicleActions.loadCatalogsVehicleFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(CatalogsVehicleActions.resetCatalogsVehicle, () => initialState),
);
